import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
'use strict';

angular
    .module('riskSelfAssessmentListControllers')
    .directive('rcsaStatusAssessorCard', directive);

directive.$inject = [];

function directive() {
    return {
        scope: {
            assessor          : '=',
            readOnly          : '=',
            isMultiSelect     : '=',
            layoutRatio       : '=?',
            toSendReminder    : '&',
            toUnlockAssessor  : '&'
        },
        restrict: 'AE',
        templateUrl: require('./rcsaStatusAssessorCard.tpl.html'),
        controller: ['$scope', '$state', 'exportService', function ($scope, $state, exportService) {

            // Show or hide actions
            $scope.showOrHideActions = function ($event) {
                if ($scope.readOnly || $scope.isMultiSelect) return;
                $scope.displayActions = !$scope.displayActions;
                $event.stopPropagation();
            }

            // Go to assessor risks
            $scope.goToAssessorRisks = function ($event) {
                $event.stopPropagation();
                $state.go('search', {
                    q: 'type=Risk',
                    h: [1000, 1003, 1020], // Root > Risk > Department
                    r: ['2004,' + $scope.assessor.DisplayName]
                });
            };

            // Unlock assessor
            $scope.unlockAssessor = function () {
                $scope.toUnlockAssessor().then(function () {
                });
            }

            // Poll export
            $scope.pollExport = function () {
              exportService.pollExport($scope.urlToExportSummaryReport(), {});
            };

            $scope.impersonateReview = function () {
                $state.go('riskSelfAssessmentAssess.assessor', { ItemPersonID: $scope.assessor.ItemPersonID }, { location: 'replace' });
            }

            // Export Summary Report
            $scope.urlToExportSummaryReport = function () {
                return environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment/Assessor@' + $scope.assessor.ItemPersonID + '/SummaryExportToReport';
            }

            // Toggle Selection
            $scope.toggleSelection = function ($event) {
                $scope.assessor.isSelected = !$scope.assessor.isSelected;
                $event.stopPropagation();
            }

            // Show review risk assessments action
            $scope.showReviewRiskAssessment = function () {
                return $scope.assessor.Status === 'ReadyForReview' || $scope.assessor.Status === 'Completed';
            };
        }],
        link: function (scope, element, attrs) {
            scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                column: 'col-sm-12'
            };

            // Display or not actions
            scope.displayActions = false;
        }
    };
}
})();
